import { initNavigation } from "./Navigation";
export default function () {
    initNavigation()
}
